import React from "react";
import { useParams } from "react-router-dom";
import FirmaPanel from "./FirmaPanel";

const AdminFirmManage = () => {
  const { id } = useParams();
  return <FirmaPanel adminFirmId={id} />;
};

export default AdminFirmManage;
